import './Banner.css'

function Banner(){
    return(
        <header className='banner'>
        <img src="/images/banner.png" alt="Principal banner"/>
        </header>
    )
}

export default Banner